export default "/images/meh.svg?2b37a9a33d34ffeb18067f7e3e4500ec";